import { render, staticRenderFns } from "./approver.vue?vue&type=template&id=5a71fbee&scoped=true"
import script from "./approver.vue?vue&type=script&lang=js"
export * from "./approver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71fbee",
  null
  
)

export default component.exports